export const CLUB_PROFILE_OVERLAY: Record<string, any> = {
  en: { settings: {
    clubsSearchTitle: "Find a club",
    clubsName: "Club name",
    clubsCountry: "Club country",
    clubsPossibleMatches: "Is your club already listed here?",
    clubsTitle: "Clubs & tennis communities",
    clubsHint: "Add the clubs where you play. Start typing and choose an existing club so everyone refers to the same place.",
    clubsSearchPlaceholder: "Search for a club…",
    clubsSearchHelp: "Type at least 2 letters. Selecting an existing club takes one tap.",
    clubsAdd: "Add",
    clubsAlreadyAdded: "Added",
    clubsAddNew: "Add “{{name}}” as a new club",
    clubsNewHint: "Only if you cannot find it above. City helps prevent duplicates.",
    clubsCity: "City",
    clubsCityPlaceholder: "e.g. Patras",
    clubsCityRequired: "Add the city before creating a new club.",
    clubsCreate: "Create & add club",
    clubsPrimary: "Primary",
    clubsMakePrimary: "Make primary",
    clubsDiscoverable: "Visible to players from this club",
    clubsDiscoverableHint: "Off by default. Turn it on only if you want future club-based player discovery.",
    clubsRemove: "Remove",
    clubsAdded: "Club added.",
    clubsCreated: "Club created and added.",
    clubsRemoved: "Club removed.",
    clubsUpdated: "Club settings updated.",
    clubsError: "Could not update your clubs.",
    clubsEmpty: "No clubs added yet.",
    clubsPrivacy: "Your club memberships are private by default. Tennis Log does not expose a public member directory."
  }},
  el: { settings: {
    clubsSearchTitle: "Βρες όμιλο",
    clubsName: "Όνομα ομίλου",
    clubsCountry: "Χώρα ομίλου",
    clubsPossibleMatches: "Μήπως ο όμιλός σου υπάρχει ήδη εδώ;",
    clubsTitle: "Όμιλοι & tennis communities",
    clubsHint: "Πρόσθεσε τους ομίλους όπου παίζεις. Ξεκίνα να γράφεις και επίλεξε υπάρχοντα όμιλο ώστε όλοι να αναφέρονται στο ίδιο club.",
    clubsSearchPlaceholder: "Αναζήτηση ομίλου…",
    clubsSearchHelp: "Γράψε τουλάχιστον 2 γράμματα. Αν υπάρχει ήδη, τον προσθέτεις με ένα tap.",
    clubsAdd: "Προσθήκη",
    clubsAlreadyAdded: "Έχει προστεθεί",
    clubsAddNew: "Πρόσθεσε το «{{name}}» ως νέο όμιλο",
    clubsNewHint: "Μόνο αν δεν τον βρίσκεις παραπάνω. Η πόλη βοηθά να αποφεύγονται διπλοεγγραφές.",
    clubsCity: "Πόλη",
    clubsCityPlaceholder: "π.χ. Πάτρα",
    clubsCityRequired: "Συμπλήρωσε την πόλη πριν δημιουργήσεις νέο όμιλο.",
    clubsCreate: "Δημιουργία & προσθήκη",
    clubsPrimary: "Κύριος όμιλος",
    clubsMakePrimary: "Ορισμός ως κύριου",
    clubsDiscoverable: "Ορατός σε παίκτες αυτού του ομίλου",
    clubsDiscoverableHint: "Απενεργοποιημένο από προεπιλογή. Ενεργοποίησέ το μόνο αν θέλεις μελλοντική εύρεση παικτών μέσω club.",
    clubsRemove: "Αφαίρεση",
    clubsAdded: "Ο όμιλος προστέθηκε.",
    clubsCreated: "Ο όμιλος δημιουργήθηκε και προστέθηκε.",
    clubsRemoved: "Ο όμιλος αφαιρέθηκε.",
    clubsUpdated: "Οι ρυθμίσεις του ομίλου ενημερώθηκαν.",
    clubsError: "Δεν ήταν δυνατή η ενημέρωση των ομίλων.",
    clubsEmpty: "Δεν έχεις προσθέσει ακόμη όμιλο.",
    clubsPrivacy: "Οι όμιλοί σου είναι ιδιωτικοί από προεπιλογή. Το Tennis Log δεν εμφανίζει δημόσιο κατάλογο μελών."
  }},
  es: { settings: {
    clubsSearchTitle: "Buscar un club",
    clubsName: "Nombre del club",
    clubsCountry: "País del club",
    clubsPossibleMatches: "¿Tu club ya aparece aquí?",
    clubsTitle: "Clubes y comunidades de tenis",
    clubsHint: "Añade los clubes donde juegas. Empieza a escribir y elige uno existente para que todos usen el mismo club.",
    clubsSearchPlaceholder: "Buscar un club…",
    clubsSearchHelp: "Escribe al menos 2 letras. Si ya existe, se añade con un toque.",
    clubsAdd: "Añadir",
    clubsAlreadyAdded: "Añadido",
    clubsAddNew: "Añadir “{{name}}” como club nuevo",
    clubsNewHint: "Solo si no aparece arriba. La ciudad ayuda a evitar duplicados.",
    clubsCity: "Ciudad",
    clubsCityPlaceholder: "p. ej. Patras",
    clubsCityRequired: "Añade la ciudad antes de crear un club nuevo.",
    clubsCreate: "Crear y añadir club",
    clubsPrimary: "Principal",
    clubsMakePrimary: "Hacer principal",
    clubsDiscoverable: "Visible para jugadores de este club",
    clubsDiscoverableHint: "Desactivado por defecto. Actívalo solo si quieres futuro descubrimiento de jugadores por club.",
    clubsRemove: "Eliminar",
    clubsAdded: "Club añadido.",
    clubsCreated: "Club creado y añadido.",
    clubsRemoved: "Club eliminado.",
    clubsUpdated: "Ajustes del club actualizados.",
    clubsError: "No se pudieron actualizar tus clubes.",
    clubsEmpty: "Aún no has añadido clubes.",
    clubsPrivacy: "Tus clubes son privados por defecto. Tennis Log no publica un directorio de miembros."
  }},
  fr: { settings: {
    clubsSearchTitle: "Trouver un club",
    clubsName: "Nom du club",
    clubsCountry: "Pays du club",
    clubsPossibleMatches: "Votre club figure-t-il déjà ici ?",
    clubsTitle: "Clubs et communautés de tennis",
    clubsHint: "Ajoutez les clubs où vous jouez. Commencez à taper puis choisissez un club existant afin que tout le monde utilise la même fiche.",
    clubsSearchPlaceholder: "Rechercher un club…",
    clubsSearchHelp: "Tapez au moins 2 lettres. S’il existe déjà, un seul appui suffit.",
    clubsAdd: "Ajouter",
    clubsAlreadyAdded: "Ajouté",
    clubsAddNew: "Ajouter « {{name}} » comme nouveau club",
    clubsNewHint: "Seulement s’il n’apparaît pas ci-dessus. La ville aide à éviter les doublons.",
    clubsCity: "Ville",
    clubsCityPlaceholder: "ex. Patras",
    clubsCityRequired: "Ajoutez la ville avant de créer un nouveau club.",
    clubsCreate: "Créer et ajouter",
    clubsPrimary: "Principal",
    clubsMakePrimary: "Définir comme principal",
    clubsDiscoverable: "Visible pour les joueurs de ce club",
    clubsDiscoverableHint: "Désactivé par défaut. Activez-le uniquement pour une future découverte de joueurs par club.",
    clubsRemove: "Retirer",
    clubsAdded: "Club ajouté.",
    clubsCreated: "Club créé et ajouté.",
    clubsRemoved: "Club retiré.",
    clubsUpdated: "Paramètres du club mis à jour.",
    clubsError: "Impossible de mettre à jour vos clubs.",
    clubsEmpty: "Aucun club ajouté pour le moment.",
    clubsPrivacy: "Vos clubs sont privés par défaut. Tennis Log ne publie pas d’annuaire des membres."
  }},
  de: { settings: {
    clubsSearchTitle: "Club finden",
    clubsName: "Clubname",
    clubsCountry: "Land des Clubs",
    clubsPossibleMatches: "Ist dein Club hier bereits aufgeführt?",
    clubsTitle: "Clubs & Tennis-Communities",
    clubsHint: "Füge die Clubs hinzu, in denen du spielst. Tippe den Namen an und wähle einen bestehenden Club, damit alle denselben Eintrag verwenden.",
    clubsSearchPlaceholder: "Club suchen…",
    clubsSearchHelp: "Mindestens 2 Zeichen eingeben. Bestehende Clubs lassen sich mit einem Tipp hinzufügen.",
    clubsAdd: "Hinzufügen",
    clubsAlreadyAdded: "Hinzugefügt",
    clubsAddNew: "„{{name}}“ als neuen Club hinzufügen",
    clubsNewHint: "Nur wenn er oben nicht erscheint. Die Stadt hilft, Duplikate zu vermeiden.",
    clubsCity: "Stadt",
    clubsCityPlaceholder: "z. B. Patras",
    clubsCityRequired: "Bitte zuerst die Stadt eingeben.",
    clubsCreate: "Club erstellen & hinzufügen",
    clubsPrimary: "Hauptclub",
    clubsMakePrimary: "Als Hauptclub festlegen",
    clubsDiscoverable: "Für Spieler dieses Clubs sichtbar",
    clubsDiscoverableHint: "Standardmäßig aus. Nur aktivieren, wenn du künftig über den Club gefunden werden möchtest.",
    clubsRemove: "Entfernen",
    clubsAdded: "Club hinzugefügt.",
    clubsCreated: "Club erstellt und hinzugefügt.",
    clubsRemoved: "Club entfernt.",
    clubsUpdated: "Club-Einstellungen aktualisiert.",
    clubsError: "Clubs konnten nicht aktualisiert werden.",
    clubsEmpty: "Noch keine Clubs hinzugefügt.",
    clubsPrivacy: "Deine Club-Zugehörigkeiten sind standardmäßig privat. Tennis Log veröffentlicht kein Mitgliederverzeichnis."
  }},
  it: { settings: {
    clubsSearchTitle: "Trova un club",
    clubsName: "Nome del club",
    clubsCountry: "Paese del club",
    clubsPossibleMatches: "Il tuo club è già presente qui?",
    clubsTitle: "Club e community di tennis",
    clubsHint: "Aggiungi i club in cui giochi. Inizia a digitare e scegli un club esistente così tutti usano la stessa voce.",
    clubsSearchPlaceholder: "Cerca un club…",
    clubsSearchHelp: "Digita almeno 2 lettere. Se esiste già, basta un tap.",
    clubsAdd: "Aggiungi",
    clubsAlreadyAdded: "Aggiunto",
    clubsAddNew: "Aggiungi “{{name}}” come nuovo club",
    clubsNewHint: "Solo se non compare sopra. La città aiuta a evitare duplicati.",
    clubsCity: "Città",
    clubsCityPlaceholder: "es. Patrasso",
    clubsCityRequired: "Inserisci la città prima di creare un nuovo club.",
    clubsCreate: "Crea e aggiungi club",
    clubsPrimary: "Principale",
    clubsMakePrimary: "Imposta come principale",
    clubsDiscoverable: "Visibile ai giocatori di questo club",
    clubsDiscoverableHint: "Disattivato per impostazione predefinita. Attivalo solo per la futura ricerca di giocatori tramite club.",
    clubsRemove: "Rimuovi",
    clubsAdded: "Club aggiunto.",
    clubsCreated: "Club creato e aggiunto.",
    clubsRemoved: "Club rimosso.",
    clubsUpdated: "Impostazioni del club aggiornate.",
    clubsError: "Impossibile aggiornare i club.",
    clubsEmpty: "Nessun club aggiunto.",
    clubsPrivacy: "Le tue appartenenze ai club sono private per impostazione predefinita. Tennis Log non pubblica un elenco dei membri."
  }},
  ja: { settings: {
    clubsSearchTitle: "クラブを探す",
    clubsName: "クラブ名",
    clubsCountry: "クラブの国",
    clubsPossibleMatches: "既に登録されているクラブはこちらですか？",
    clubsTitle: "クラブ & テニスコミュニティ",
    clubsHint: "プレーしているクラブを追加します。入力を始め、既存のクラブを選ぶことで全員が同じクラブ情報を使えます。",
    clubsSearchPlaceholder: "クラブを検索…",
    clubsSearchHelp: "2文字以上入力してください。既存クラブなら1タップで追加できます。",
    clubsAdd: "追加",
    clubsAlreadyAdded: "追加済み",
    clubsAddNew: "「{{name}}」を新しいクラブとして追加",
    clubsNewHint: "上に見つからない場合のみ。都市を入力すると重複を防ぎやすくなります。",
    clubsCity: "都市",
    clubsCityPlaceholder: "例: Patras",
    clubsCityRequired: "新しいクラブを作成する前に都市を入力してください。",
    clubsCreate: "作成して追加",
    clubsPrimary: "メインクラブ",
    clubsMakePrimary: "メインに設定",
    clubsDiscoverable: "このクラブのプレーヤーに表示",
    clubsDiscoverableHint: "初期設定はオフです。将来クラブ経由で他のプレーヤーに見つけてもらいたい場合のみオンにしてください。",
    clubsRemove: "削除",
    clubsAdded: "クラブを追加しました。",
    clubsCreated: "クラブを作成して追加しました。",
    clubsRemoved: "クラブを削除しました。",
    clubsUpdated: "クラブ設定を更新しました。",
    clubsError: "クラブを更新できませんでした。",
    clubsEmpty: "まだクラブを追加していません。",
    clubsPrivacy: "クラブ所属は初期設定で非公開です。Tennis Logは公開メンバー一覧を作りません。"
  }}
};
